export class KioskChangeApplicationModel {
    public id: number;
    public applicationType: number;
    public isActive: boolean;
}
